import React, { useState, useEffect, useRef } from "react";
import "./TotalReach.scss";
import ChartName from "../../../../../Dashboard/Charts/ChartName";
import html2canvas from "html2canvas";
import { downloadCanvasWithTitle, downloadCSVData } from "../../../../../Dashboard/Charts/utils";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";
import DeleteWidget from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as MoreOptions } from "../../../../../../../assets/svg/menu.svg";
import { ReactComponent as CloneIcon } from "../../../../../../../assets/svg/clone-icon.svg";
import ChartOptionsSidebar from "../../../../../Dashboard/Charts/ChartsOptionsSidebar/ChartOptionsSidebar";
import InstagramPageSelector from "../InstagramPageSelector";
import { ReactComponent as ArrowIcon } from "../../../../../../../assets/svg/chevron.svg";
import { ChartFilterIcon } from "../../../../../Dashboard/Charts/ChartFilterOptions";
import UpIcon from "../../../../../../../assets/svg/percentage_arrow.svg";
import { kFormatter, percentageFormatter } from "../../../../../Dashboard/Charts/utils";
import DownIcon from "../../../../../../../assets/svg/arrow-down.svg";
import moment from "moment-timezone";
import { ReactComponent as Settings } from "../../../../../../../assets/svg/settings.svg";
import { ReactComponent as MiniMize } from "../../../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../../../assets/svg/zoom_out_map.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import DownloadChart from "../../../../../Dashboard/Charts/DownloadChart";

function TotalReach(props) {
    const [isNoData, setIsNoData] = useState(false);

    const chart = useRef(null);
    const chartLoading = props.chartDataLoading;
    const chartData = props?.data;

    useEffect(() => {
        setIsNoData(props.pageStatus || props?.data?.nodata);
    }, [props.data, props.pageStatus]);

    const renderDownloadButton = (nodata) => {
        return (
            <DownloadChart
                nodata={nodata}
                options={[
                    { name: "CSV", downloadFn: downLoadCSV },
                    { name: "PNG", downloadFn: downLoadPNG, showLoader: true },
                ]}
            />
        );
    };

    const downLoadCSV = () => {
        let chartName = "Total Post Reach";
        let postCount = chartData?.reach1;

        let preCount = chartData?.reach2;

        let downLoadingData = [];
        let durationGap = chartData?.durationGap + 1;

        downLoadingData.push(["Duration", "Current", "Average", "Previous", "Percentage change"]);
        let percentage = chartData?.reach_percentage_change;
        if (preCount) downLoadingData.push([durationGap + " days", postCount, chartData?.avg_reach, preCount, percentage + "%"]);
        else downLoadingData.push([durationGap + " days", postCount, chartData?.avg_reach, "NA", "NA"]);

        downloadCSVData(downLoadingData, chartName);
    };

    const downLoadPNG = (cb) => {
        if (chart?.current)
            return html2canvas(chart.current, { backgroundColor: "#fff", allowTaint: true, useCORS: true, scrollX: 0, scrollY: -window.scrollY }).then(
                (canvas) => {
                    cb && cb();
                    // downloadCanvasWithTitle(canvas, props.widget?.name || "Total Posts Reach");
                    downloadCanvasWithTitle(canvas, "Total Post Reach");
                },
            );
    };
    const customChangeShowMoreOptions = (e) => {
        let parent = props.containerRef.current.getBoundingClientRect();
        if (e && !props.showMoreOptions) {
            props.changeShowMoreOptions(true);
            props.changeShowMoreOptionsLoc({ x: e.clientX - parent.left - 160, y: e.clientY - parent.top });
        } else {
            props.changeShowMoreOptions(false);
            props.changeShowMoreOptionsLoc(null);
        }
    };
    const increment = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex < pageList.length - 1) {
            let item = pageList[pageIndex + 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[0];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };
    const decrement = () => {
        const selectedPage = props.selectedInstagramPage;
        const pageList = props.instagramPageList;
        const pageIndex = pageList.findIndex((ele) => ele.page_id === selectedPage.value);
        if (pageIndex === 0) {
            let item = pageList[pageList.length - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        } else {
            let item = pageList[pageIndex - 1];
            let obj = {};
            obj["label"] = `${item.page_name} (${item.status})`;
            obj["id"] = item.id;
            obj["value"] = item.page_id;
            obj["access_token"] = item.access_token;
            props.setSelectedInstagramPage(obj);
        }
    };

    const currentReach = () => {
        let count = chartData?.reach1;
        return kFormatter(count) || "";
    };

    const elements = (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    IsInstagram
                    name={"Total Post Reach"}
                    isIGPage={props.isIGPage}
                    info="This chart represents the total reach for a specific period of time. The average is obtained by dividing the total reach by total number of posts, and the percentage change is obtained by comparing the current data with the prior data for the chosen period of time."
                    //info="Total reach percentage change based on duration selection. 28 days previous duration data will be available for this chart from the day you authenticate your Business page."
                />

                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!props.isIGPage &&
                        !props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}
                    {!props.isPublic && !props.isResearchDashboard && !isNoData && renderDownloadButton(isNoData)}
                    {
                        <>
                            {props.isIGPage || (props.isPublic && isNoData) ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expand ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expand ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {!props.isIGPage && (
                        <>
                            {props.isPublic && isNoData ? null : (
                                <MoreOptions
                                    className={isNoData && props.isIGPage ? "pointer-disabled" : "more-options"}
                                    onClick={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}
                                />
                            )}
                        </>
                    )}
                </div>
                {props.showMoreOptions && (
                    <ChartOptionsSidebar
                        data-html2canvas-ignore="true"
                        showMoreOptionsLoc={props.showMoreOptionsLoc}
                        changeShowMoreOptions={props.isIGPage ? (e) => customChangeShowMoreOptions(e) : (e) => props.changeShowMoreOptions(e)}>
                        {!props.isIGPage &&
                            !props.isPublic &&
                            !props.isStandardDashboard &&
                            !props.isResearchDashboard &&
                            props.dashboardPageType !== "temporaryInsights" &&
                            props.dashboardPageType !== "temporary" && (
                                <>
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                    <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                        <span>Clone Chart</span>
                                        <CloneIcon />
                                    </div>
                                    <DeleteWidget onClick={props.deleteWidget} />
                                </>
                            )}
                    </ChartOptionsSidebar>
                )}
            </div>

            {/* <div className="dashboard-chart dashboard-chart-slider skiptranslate"> */}
            {/* {!props.isIGPage && (
                    <div
                        data-html2canvas-ignore="true"
                        className={`chart-slider chart-slider-left ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                        onClick={() => decrement()}>
                        <ArrowIcon />
                    </div>
                )} */}
            <div className="chart-area" style={{ height: "100%" }} ref={chart}>
                {!props.isIGPage && (
                    <InstagramPageSelector
                        selectedPage={props.selectedInstagramPage}
                        setSelectedPage={props.setSelectedInstagramPage}
                        pageList={props.instagramPageList}
                        widgetContainerRef={props.widgetContainerRef}
                    />
                )}
                {chartLoading && <Loading />}
                {isNoData && !chartLoading && (
                    <div className={`${props.isIGPage ? "no__data-page-text" : "m-top"}`}>
                        <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />
                    </div>
                )}
                {!isNoData && !chartLoading && (
                    <div className="chart__content">
                        <div className=" count-wrapper">
                            <div className="current__count">
                                {currentReach()}
                                {/* <span className="chart__text">{name}</span> */}
                            </div>
                            <div className="chart__text count-wrapper-text">Reach</div>
                        </div>
                        {/* <div className="current__count">{currentReach()}</div> */}
                        {/* <div className="zzz"> */}
                        {/* <div className="chart__text">Reach</div> */}
                        <div className="lower-chart-content">
                            {chartData?.avg_reach && (
                                <div className="chart__text">
                                    Avg Reach
                                    <span className="avg__val"> {chartData?.avg_reach}</span>
                                </div>
                            )}

                            {chartData?.reach_percentage_change ? (
                                chartData?.reach_percentage_change > 0 ? (
                                    <div className="chart__percentage-wrapper">
                                        <div className="percentage__chart__text">Change % </div>
                                        <img src={UpIcon} className="up__icon" />
                                        <div className="percentage__count">{percentageFormatter(chartData?.reach_percentage_change) + "%" || 0}</div>

                                        {/* <img src={UpIcon} className="up__icon" />
                                            <div className="percentage__count">{chartData?.reach_percentage_change + "%" || 0}</div> */}
                                    </div>
                                ) : (
                                    <div className="chart__percentage-wrapper">
                                        <div className="percentage__chart__text">Change % </div>
                                        <img src={DownIcon} className="down__icon" />
                                        <div className="percentage__count-less">{percentageFormatter(chartData?.reach_percentage_change) + "%" || 0}</div>
                                    </div>
                                )
                            ) : (
                                <div className="chart__percentage-wrapper">
                                    <div className="percentage__chart__text">Change %</div>
                                    <div className="chart__text">{chartData?.reach_percentage_change == 0 ? 0 : "NA"}</div>
                                </div>
                            )}
                            {/* </div> */}
                        </div>
                    </div>
                )}
            </div>
            {!props.isIGPage && (
                <div
                    data-html2canvas-ignore="true"
                    className={`chart-slider chart-slider-right ${props.instagramPageList.length === 1 ? "disabled" : ""}`}
                    onClick={() => increment()}>
                    <ArrowIcon />
                </div>
            )}
            {/* </div> */}
        </>
    );
    return props.isIGPage ? <div className="dashboard-widget-container">{elements}</div> : <>{elements}</>;
}
export default TotalReach;
